import { atomic } from "../atomic.css";

export function ListEndMarker() {
  return <div className={atomic({ borderBlockStart: "dashed" })} />;
}
